import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_PRODUCT_FEATURE_REQUEST =
  'ProductFeature/FETCH_PRODUCT_FEATURE_REQUEST'
const FETCH_PRODUCT_FEATURE_SUCCESS =
  'ProductFeature/FETCH_PRODUCT_FEATURE_SUCCESS'
const FETCH_PRODUCT_FEATURE_FAILURE =
  'ProductFeature/FETCH_PRODUCT_FEATURE_FAILURE'

const FETCH_PRODUCT_FEATURE_BY_ID_REQUEST =
  'ProductFeature/FETCH_PRODUCT_FEATURE_BY_ID_REQUEST'
const FETCH_PRODUCT_FEATURE_BY_ID_SUCCESS =
  'ProductFeature/FETCH_PRODUCT_FEATURE_BY_ID_SUCCESS'
const FETCH_PRODUCT_FEATURE_BY_ID_FAILURE =
  'ProductFeature/FETCH_PRODUCT_FEATURE_BY_ID_FAILURE'

const CREATE_PRODUCT_FEATURE_REQUEST =
  'ProductFeature/CREATE_PRODUCT_FEATURE_REQUEST'
const CREATE_PRODUCT_FEATURE_SUCCESS =
  'ProductFeature/CREATE_PRODUCT_FEATURE_SUCCESS'
const CREATE_PRODUCT_FEATURE_FAILURE =
  'ProductFeature/CREATE_PRODUCT_FEATURE_FAILURE'

const UPDATE_PRODUCT_FEATURE_REQUEST =
  'ProductFeature/UPDATE_PRODUCT_FEATURE_REQUEST'
const UPDATE_PRODUCT_FEATURE_SUCCESS =
  'ProductFeature/UPDATE_PRODUCT_FEATURE_SUCCESS'
const UPDATE_PRODUCT_FEATURE_FAILURE =
  'ProductFeature/UPDATE_PRODUCT_FEATURE_FAILURE'

const DELETE_PRODUCT_FEATURE_REQUEST =
  'ProductFeature/DELETE_PRODUCT_FEATURE_REQUEST'
const DELETE_PRODUCT_FEATURE_SUCCESS =
  'ProductFeature/DELETE_PRODUCT_FEATURE_SUCCESS'
const DELETE_PRODUCT_FEATURE_FAILURE =
  'ProductFeature/DELETE_PRODUCT_FEATURE_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  productFeatureList: [],
  productFeatureObj: {}
}

// Default Reducer
const productFeature = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_FEATURE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_PRODUCT_FEATURE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        productFeatureList: action.payload
      }
    case FETCH_PRODUCT_FEATURE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_PRODUCT_FEATURE_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_PRODUCT_FEATURE_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        productFeatureObj: action.payload
      }
    case FETCH_PRODUCT_FEATURE_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_PRODUCT_FEATURE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_PRODUCT_FEATURE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_PRODUCT_FEATURE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_PRODUCT_FEATURE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_PRODUCT_FEATURE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_PRODUCT_FEATURE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_PRODUCT_FEATURE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_PRODUCT_FEATURE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_PRODUCT_FEATURE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

export default productFeature

// Action Creators
export const fetchProductFeatureList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_PRODUCT_FEATURE_REQUEST
      })

      const response = await API.get(EndPoints.PRODUCT_FEATURE)
      dispatch({
        type: FETCH_PRODUCT_FEATURE_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_PRODUCT_FEATURE_FAILURE
      })
    }
  }
}

export const createProductFeature = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_PRODUCT_FEATURE_REQUEST
      })

      await API.post(EndPoints.PRODUCT_FEATURE, data)
      dispatch({
        type: CREATE_PRODUCT_FEATURE_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_PRODUCT_FEATURE_FAILURE
      })
    }
  }
}

export const updateProductFeature = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_PRODUCT_FEATURE_REQUEST
      })

      await API.put(EndPoints.PRODUCT_FEATURE, data)
      dispatch({
        type: UPDATE_PRODUCT_FEATURE_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_PRODUCT_FEATURE_FAILURE
      })
    }
  }
}

export const deleteProductFeature = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_PRODUCT_FEATURE_REQUEST
      })

      await API.delete(EndPoints.PRODUCT_FEATURE + `/${id}`)
      dispatch({
        type: DELETE_PRODUCT_FEATURE_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_PRODUCT_FEATURE_FAILURE
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/productFeature.js